/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const currencyStr = window.Shopify.currency.active;

      const thresholdMap = {
        //If using a currency with a specific free shipping threshold set in the settings, use that as the minimum
        USD: window.theme.freeShippingThresholds.usd * 100,
        EUR: window.theme.freeShippingThresholds.eur * 100,
        CAD: window.theme.freeShippingThresholds.cad * 100,
        AUD: window.theme.freeShippingThresholds.aud * 100,

        //Else the currency is UK (or a region with a custom free shipping threshold) so use the standard converison rate
        default: window.theme.freeShippingThresholds.default * 100 * window.Shopify.currency.rate
      };

      const minimum = thresholdMap[currencyStr] || thresholdMap.default;

      let amount_text = this.querySelector('.free-shipping--text span');
      //Cart total
      let total = parseInt(this.dataset.cartTotal, 10);

      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);

    }
  }
  customElements.define('free-shipping', FreeShipping);
}